import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function PricingTeaser() {
  return (
    <section style={{ padding: "clamp(30px,3.5vw,48px) clamp(20px,5vw,80px)", background: "linear-gradient(to bottom, #FFFFFF 0%, #F4F1E7 100%)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{
          background: "#112215",
          borderRadius: 20,
          overflow: "hidden",
          display: "grid",
          gridTemplateColumns: "1.4fr 1fr",
          minHeight: 150,
        }} className="pricing-teaser-grid">
          {/* Left copy */}
          <div style={{ padding: "clamp(32px,5vw,48px)", display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#CCF5AC", marginBottom: 14, marginTop: 0 }}>
              Simple pricing
            </p>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(22px, 3vw, 36px)", letterSpacing: "-0.02em", lineHeight: 1.2, color: "#F4F1E7", marginTop: 0, marginBottom: 16 }}>
              From 12% + VAT.<br />Includes the whole operation.
            </h2>
            <p style={{ fontFamily: "'Inter', sans-serif",               fontSize: 15, color: "rgba(244,241,231,0.82)", lineHeight: 1.7, marginTop: 0, marginBottom: 20, maxWidth: 460 }}>
              One fee covers everything - multi-platform listings, dynamic pricing, 24/7 guest communication, housekeeping, maintenance coordination, owner reporting and compliance. No setup fees, no monthly retainer. We're paid per booking, so we only earn when you do.
            </p>
            <Link to="/pricing" style={{ background: "none", border: "none", color: "#CCF5AC", fontFamily: "'Inter', sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer", padding: 0, display: "inline-flex", alignItems: "center", gap: 6, textDecoration: "none" }}>
              See full pricing <ArrowRight size={15} />
            </Link>
          </div>

          {/* Right - full-bleed photo */}
          <img
            src="https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/6df592113_generated_image.png"
            alt="The Truestays team managing short-let properties"
            style={{ width: "100%", height: "100%", minHeight: 150, objectFit: "cover", display: "block" }}
          />
        </div>
      </div>
      <style>{`
        @media (max-width: 640px) { .pricing-teaser-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}